<template>
  <div class="card mb-0 border-0 shadow-0 ">
    <div 
      :class="['card-body text-center', padding ? ' py-5 mb-5':' py-4 mb-2 mt-2']"
    >
      <div 
        :class="['mb-3', padding ? ' mt-5':'']"
      >
        <img
          src="@/assets/global_assets/images/subscription_expired.png"
          class=""
          alt=""
          :width="imgWidth"
        >
      </div>
      <h1 
        class="error-page-title"
        :style="'font-size:'+titleSize+' !important'"
      >
        {{ $t('Subscription Expired') + '!' }}
      </h1>
      <div 
        class="error-page-text"
        :style="'font-size:'+bodySize+' !important'"
      >
        <div>{{ $t("Your package has expired. If you want to continue using it, please press 'Upgrade Now'.") }}</div>
        <div>{{ $t('If you feel this is a mistake, contact your admin.') }}</div>
      </div>
      <div class="mt-4">
        <button 
          v-if="isConfirm"
          class="btn btn-lg btn-outline-primary mr-2" 
          @click="closeModal()"
        > 
          <i class="fa-solid fa-thumbs-up mr-1" />{{ $t('OK') }}
        </button>
        <button
          class="btn btn-lg btn-primary"
          @click="redirectTo()"
        >
          <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t('Upgrade Now') + "!" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    components: {},
    props: {
        imgWidth: {
            type: String,
            default: '389.77px'
        },
        titleSize: {
            type: String,
            default: '25px'
        },
        bodySize: {
            type: String,
            default: '15px'
        },
        isConfirm: {
          type: Boolean,
          default: false
        },
        padding: {
          type: Boolean,
          default: true
        },
    },
    data() {
        return {
            redirect: 'https://gosell.tech/price',
        }
    },
    methods: {
        redirectTo() {
            window.location.href = this.redirect;
        },
        closeModal(){
          if(this.isConfirm){
            this.$parent.closeModal();
          }
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/error-page/templates/SubscriptionExpired.vue